import { proxy } from 'valtio';

import { DiagramConnection } from 'models';

import { useSnapshot } from 'hooks/use-safe-snapshot';

export const highlightedConnectionState = proxy({
    highlightedConnection: null as DiagramConnection['id'] | null,
});

const useHighlightedConnection = () => {
    const { highlightedConnection } = useSnapshot(highlightedConnectionState);

    const isHighlighted = (connection: DiagramConnection) => {
        return highlightedConnection === connection.id;
    };

    return {
        highlightedConnection,
        isHighlighted,
    };
};

const useHighlightedConnectionSetter = () => {
    const highlight = (connection: DiagramConnection) => {
        highlightedConnectionState.highlightedConnection = connection.id;
    };

    const clear = () => {
        highlightedConnectionState.highlightedConnection = null;
    };

    return {
        highlight,
        clear,
    };
};

export { useHighlightedConnection, useHighlightedConnectionSetter };
